<template>
  <div class="alert alert-warning mb-3">
    <strong>{{ impact.title }}</strong>
    <CdrSubExaminationImpactContent :impact="impact" />
  </div>
</template>

<script>
import CdrSubExaminationImpactContent from "./CdrSubExaminationImpactContent.vue";

export default {
  components: { CdrSubExaminationImpactContent },
  props: {
    impact: { type: Object, required: true },
  },
};
</script>
